/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { DocumentVisibility } from "cnam/types/types";
import emberSwal from "ui-kit/utils/ember-swal";
let DocumentsRetrieveAccessFormShowContentComponent = (_class = class DocumentsRetrieveAccessFormShowContentComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "shouldShowVisibilityAlert", _descriptor, this);
    if ((this.hiddenToPatient || this.hiddenToLegalRepresentatives) && this.shouldShowVisibilityAlert) {
      const title = `Vous allez consulter un document ${this.hiddenToPatient ? "non visible par le patient" : "non visible par les représentants légaux"}`;
      emberSwal.fire({
        title,
        text: "Êtes-vous sûr de vouloir le consulter ?",
        icon: "warning",
        cancelButtonText: "Consulter",
        showCancelButton: true,
        confirmButtonText: "Revenir à la liste de documents",
        confirmButtonColor: "#d33"
      }).then(result => {
        if (result.isConfirmed) {
          this.args.returnToDocuments();
        } else {
          this.shouldShowVisibilityAlert = false;
        }
      });
    } else {
      this.shouldShowVisibilityAlert = false;
    }
  }
  get isRunning() {
    return this.args.isRunning || this.shouldShowVisibilityAlert;
  }
  get hiddenToPatient() {
    return this.args.metadata?.confidentialities.includes(DocumentVisibility.HIDDEN_TO_PATIENT);
  }
  get hiddenToLegalRepresentatives() {
    return this.args.metadata?.confidentialities.includes(DocumentVisibility.HIDDEN_TO_LEGAL_REPRESENTATIVES);
  }
  get addedByPatient() {
    return this.args.metadata?.classCode == "90";
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "shouldShowVisibilityAlert", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _class);
export { DocumentsRetrieveAccessFormShowContentComponent as default };